
import {getLoginToken, getSelectedProject} from '../common/common.js'
import React, { Fragment, useState } from 'react';
import {
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    Show,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    NumberField,
    ReferenceInput,
    AutocompleteInput,
    AutocompleteArrayInput,
    useNotify,
    Toolbar,
    SaveButton,
    ReferenceField,
    FileInput,
    FileField,
    SingleFieldList,
    FunctionField,
    DateField,
    DateInput,
    useRecordContext,
    DateTimeInput,
    TopToolbar,
    Button as RaButton,
    useRefresh,
    ReferenceArrayField,
    ReferenceArrayInput,
    ChipField,
} from 'react-admin';

import {
    Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField as MuiTextField,
    Button, Box, CircularProgress, Avatar, CardContent, CardActions, CardHeader, Card, Grid
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom'

//Custom Import Start

//Custom Import End

const ResourceHistoryFilter = props => (
    <Filter {...props}>

        <ReferenceInput label="Resource" source="resource_id" reference="resource" alwaysOn>
            <AutocompleteInput optionText="entity" />
        </ReferenceInput>

        <ReferenceInput source="member_no" reference="user" alwaysOn filter={{project_id:getSelectedProject()}}>
            <AutocompleteInput label="Member" optionText="name" />
        </ReferenceInput>

        {
            //Custom Filter Start

            //Custom Filter End
        }
    </Filter>
);

export const ResourceHistoryList = props => {
    const navigate = useNavigate()
    const refresh = useRefresh();

    //Custom List Code Start

    //Custom List Code End
    return (
        <List title="History" {...props} filters={<ResourceHistoryFilter />} mutationMode='optimistic'
            exporter={false}
            sort={{ field: 'reg_date', order: 'DESC' }}
            perPage={30}
        //Custom List Action Start

        //Custom List Action End
        >
            {
                //Custom List Body Start

                //Custom List Body End
            }
            <Datagrid bulkActionButtons={false}>
                <ReferenceField label="Project" source="project_id" reference="project">
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField label="Member" source="member_no" reference="user">
                    <TextField source="name" />
                </ReferenceField>
                <DateField label="Date" source="reg_date" showTime locales={'ko'}/>
                <TextField label="Action" source="action" />
                <TextField label="Resrouce" source="resource" />
                <TextField label="ResrouceId" source="resource_id" />
            </Datagrid>
        </List>
    )
};
